/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeEvery, call, put, select } from 'redux-saga/effects'
import { applyFilter, setPcrList } from '../store/home.actions'
import { getUserSelector } from '../../user/selectors'
import { IUserState } from '../../user/store/user.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { UserConstants } from '../../user/store/user.constants'
import Logger from '../../../services/logger.service'
import { HomeConstants } from '../store/home.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IPcrSummaries } from '../store/home.types'

function* getAllPcrDocs() {
  const user: IUserState = yield select(getUserSelector)
  const { serviceId, userId } = user
  if (!serviceId || !userId) {
    return
  }
  const pcrDocsService = new PcrDocsService(serviceId)
  try {
    const pcrDocs: IPcrSummaries = yield call([pcrDocsService, pcrDocsService.getPCRDocsPerUser], userId)
    yield put(setPcrList(pcrDocs))
    yield put(applyFilter())
  } catch (e) {
    Logger.error(`Error getting pcr documents for user: ${userId} - Reason: ${e}`)
  }
}

export function* getAllPcrDocsSaga() {
  yield takeEvery([UserConstants.SET_SERVICE, HomeConstants.GET_ALL_PCR_DOCS], performWithMutexHOG, getAllPcrDocs)
}
